import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Scroll to top on link click
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="compact-footer">
      <div className="footer-content">
        {/* Brand + Logo */}
        <div className="footer-brand">
          <img src="/images/Logo.png" alt="HarryGen Logo" className="footer-logo" />
          <span>Harrygen Labs Pvt. Ltd.</span>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
            <li><Link to="/about" onClick={handleLinkClick}>About</Link></li>
            <li><Link to="/products" onClick={handleLinkClick}>Products</Link></li>
            <li><Link to="/presence" onClick={handleLinkClick}>Presence</Link></li>
            <li><Link to="/contact" onClick={handleLinkClick}>Contact</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>Email: <a href="mailto:info@harrygenlabs.com">info@harrygenlabs.com</a></p>
        </div>

        {/* Social */}
        <div className="footer-social">
          <h4>Follow Us</h4>
          <a href="https://www.facebook.com/share/19NkN32mwe/" target="_blank" rel="noreferrer"><FaFacebookF /></a>
          <a href="https://www.instagram.com/harrygenlabs?utm_source=qr&igsh=MWw5a2tlc2RxZ2tsYg==" target="_blank" rel="noreferrer"><FaInstagram /></a>
        </div>
      </div>

      <p className="footer-copy">© {new Date().getFullYear()} Harrygen Labs | All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
